var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 19.2996L4.27502 12.6996C4.17502 12.5996 4.10402 12.4912 4.06202 12.3746C4.02002 12.2579 3.99935 12.1329 4.00002 11.9996C4.00002 11.8662 4.02102 11.7412 4.06302 11.6246C4.10502 11.5079 4.17568 11.3996 4.27502 11.2996L10.875 4.69957C11.0583 4.51624 11.2877 4.42057 11.563 4.41257C11.8383 4.40457 12.0757 4.50024 12.275 4.69957C12.475 4.88291 12.5793 5.11224 12.588 5.38757C12.5967 5.66291 12.5007 5.90024 12.3 6.09957L7.40002 10.9996H18.575C18.8583 10.9996 19.096 11.0956 19.288 11.2876C19.48 11.4796 19.5757 11.7169 19.575 11.9996C19.575 12.2829 19.4793 12.5206 19.288 12.7126C19.0967 12.9046 18.859 13.0002 18.575 12.9996H7.40002L12.3 17.8996C12.4833 18.0829 12.5793 18.3162 12.588 18.5996C12.5967 18.8829 12.5007 19.1162 12.3 19.2996C12.1167 19.4996 11.8833 19.5996 11.6 19.5996C11.3167 19.5996 11.075 19.4996 10.875 19.2996Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d34d0c112937261e464873999e124fff.svg";
export { ForwardRef as ReactComponent };